import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import './Sass/AbroadCustomerDataUsageBlock.scss';
import {saveToHistory, setActiveLobbyTab, setIsPortrait, setDataUsageKey} from '../CellcomAbroadLobbyBlock/cellcomAbroadBlockSlice';
import {getUsageData} from '../CellcomAbroadLobbyBlock/Shared/abroadThunk';
import {useFetchFamilyBundle} from '../AbroadCustomerUsageGraphsBlock/hooks/useFamilyBundleUsage';
import UsageCycle from './components/UsageCycle';
import NoData from './components/NoData';
import PlaneLoader from '../AbroadTicketBlock/PlaneLoader';
import BottomDisclaimer from './components/BottomDisclaimer';
import {gaEvent} from '../../../utilities/analytics/tracking';
import gaParams from '../../../utilities/analytics/constants';
import {isMobileOnly as isMobile, isTablet} from 'react-device-detect';
import Config from '../../../Config';
import arrow from './images/arrow.svg';
// import authenticationProvider from "../../../utilities/authentication/authenticationProvider";

const AbroadCustomerDataUsageMain = (props) => {
  const isBusinessIndividual = props.data.epiStyleInitializationData.businessIndividualLobby;
  const [isLoading, setLoading] = useState(true);

  useFetchFamilyBundle(props.costumerMobile);

  const getGeneralOtpUser = () => {
    if (isBusinessIndividual && props?.data?.businessIndividualData?.selectedAccountNumber)
      return props.data.businessIndividualData.selectedAccountNumber;
    else if (props?.subscriberData?.otpPhone) return props.subscriberData.otpPhone;
    else if (props?.loginUserData?.userDetails?.contactNumber) return props.loginUserData.userDetails.contactNumber;

    return '';
  };
  //Tablet resolution fix
  useEffect(() => {
    props.setIsPortrait(props.isPortrait);
  }, [props.isPortrait]);

  useEffect(() => {
    const generalOtpUserPhone = getGeneralOtpUser();
    if (generalOtpUserPhone) {
      props
        .getUsageData({
          subscriber: generalOtpUserPhone,
          toReport: true,
        })
        .then((res) => {
          setLoading(false);

          let packageParams = '';
          if (res.payload.Body == undefined || res.payload.Body == null) {
            packageParams = 'אין מידע';
          } else {
            if (
              res.payload.Body.thisCycle.abroadBankPackages != null ||
              res.payload.Body.thisCycle.discountTariffPackage != null ||
              res.payload.Body.thisCycle.overheadTariffPackage != null ||
              res.payload.Body.previousCycle.abroadBankPackages != null ||
              res.payload.Body.previousCycle.discountTariffPackage != null ||
              res.payload.Body.previousCycle.overheadTariffPackage != null
            ) {
              const arrPackages = [];
              if (res.payload.Body.thisCycle.abroadBankPackages != null) arrPackages.push('שימושים במסגרת חבילות');
              if (res.payload.Body.thisCycle.discountTariffPackage != null) arrPackages.push('שימושים בתעריף מוזל');
              if (res.payload.Body.thisCycle.overheadTariffPackage != null) arrPackages.push('שימושים בתעריף מזדמן');
              packageParams = arrPackages.join(', ');
            } else {
              packageParams = 'לא קיימים נתונים';
            }

            props.saveToHistory();
            props.setDataUsageKey(`state::${window.location.pathname}::${window.location.hash}`);
          }
          gaEvent(gaParams.ABROAD_DATAUSAGES_SHOW.category, gaParams.ABROAD_DATAUSAGES_SHOW.eventType, packageParams);
        });
    } else {
      setLoading(false);
      // if (props.iContent.lobbyPage.value == null) {
      //   props.context.navigateTo(props.currPath);
      // } else {
      //   props.context.navigateTo(props.iContent.lobbyPage.value.url);
      // }
    }
  }, [
    props?.data?.businessIndividualData?.selectedAccountNumber,
    props?.subscriberData?.otpPhone,
    props?.loginUserData?.isSilentOtpAuthenticated,
  ]);

  const handleHulClick = () => {
    gaEvent(
      gaParams.ABROAD_DATAUSAGES_BACKTOLOBBYCLICK.category,
      gaParams.ABROAD_DATAUSAGES_BACKTOLOBBYCLICK.eventType,
      gaParams.ABROAD_DATAUSAGES_BACKTOLOBBYCLICK.eventParams,
    );
    if (props?.iContent?.selfCareAbroadLink?.value == null) {
      props.context.navigateTo(props.currPath);
    } else {
      props.context.navigateTo(props?.iContent?.selfCareAbroadLink?.value?.url);
    }
  };
  const dataExists = () => {
    return (
      props.usageData.thisCycle.abroadBankPackages != null ||
      props.usageData.thisCycle.discountTariffPackage != null ||
      props.usageData.thisCycle.overheadTariffPackage != null ||
      props.usageData.previousCycle.abroadBankPackages != null ||
      props.usageData.previousCycle.discountTariffPackage != null ||
      props.usageData.previousCycle.overheadTariffPackage != null
    );
  };
  let cycleDisplay = '';
  if (isLoading || props.isFamilyBundlePending) {
    cycleDisplay = (
      <div className='DataUsageLoaderWrapper'>
        <PlaneLoader />
      </div>
    );
  } else {
    if (props.usageData != null && (props.usageData.thisCycle != null || props.usageData.previousCycle != null)) {
      if (dataExists()) {
        cycleDisplay = (
          <>
            <p className='heading m-0 p-0'>שימושי חו"ל למנוי</p>
            <p className='subscriberNo heading m-0 p-0'>{getGeneralOtpUser()}</p>
            <a
              className='back-to-lobby'
              href='#'
              onClick={() => {
                handleHulClick();
              }}>
              חזרה לאזור האישי
              <div className='back-arrow' style={{backgroundImage:arrow.bg()}}></div>
            </a>
            <UsageCycle
              setActiveLobbyTab={props.setActiveLobbyTab}
              thisCycle={props.usageData == null ? null : props.usageData.thisCycle}
              currentCycle={true}
              context={props.context}
              iContent={props.iContent}
              currPath={props.currPath}
            />
            {props.usageData.previousCycle ? (
              <UsageCycle
                setActiveLobbyTab={props.setActiveLobbyTab}
                thisCycle={props.usageData == null ? null : props.usageData.previousCycle}
                currentCycle={false}
                currPath={props.currPath}
              />
            ) : null}
            <BottomDisclaimer />
          </>
        );
      } else {
        cycleDisplay = <NoData />;
      }
    } else {
      cycleDisplay = <NoData />;
    }
  }
  const backgroundImage =
    isMobile || (isTablet && props.isPortrait) || props.data.isSmallResolution
      ? {
          backgroundImage: `url(${Config.epiBaseUrl + props.data.epiStyleInitializationData.lobbyBackgroundImageMobile})`,
        }
      : {
          backgroundImage: `url(${Config.epiBaseUrl + props.data.epiStyleInitializationData.lobbyBackgroundImageDesktop})`,
        };
  return (
    <div className='AbroadCustomerDataUsageBlock_Wrapper'>
      <div className='container'>
        <div className='AbroadCustomerDataUsageBlock_topHeading'>{cycleDisplay}</div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    usageData: state.cellcomAbroad.subscriberAbroadUsageData,
    subscriberData: state.cellcomAbroad.otpData,
    currPath: state.cellcomAbroad.epiStyleInitializationData.currentLobbyPath,
    mobileBackground: state.cellcomAbroad.epiStyleInitializationData.lobbyBackgroundImageMobile,
    desktopBackground: state.cellcomAbroad.epiStyleInitializationData.lobbyBackgroundImageDesktop,
    data: state.cellcomAbroad,
    loginUserData: state.authentication?.loginData,
    isFamilyBundlePending: state.cellcomAbroad.familyPackageUsageDetails?.isPending,
    costumerMobile: state.selfcarePage?.selectedSubscriber?.productSubscriberNo,
  };
};

const mapDispatchToProps = {
  getUsageData,
  setActiveLobbyTab,
  setIsPortrait,
  saveToHistory,
  setDataUsageKey,
};

export default connect(mapStateToProps, mapDispatchToProps)(AbroadCustomerDataUsageMain);
